export const USER_GENDER = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  OTHER: 'OTHER'
}

export const USER_GENDER_LABEL_MAPPER = {
  [USER_GENDER.MALE]: 'gender.male',
  [USER_GENDER.FEMALE]: 'gender.female',
  [USER_GENDER.OTHER]: 'gender.other',
  [undefined]: 'no.data'
}

export const USER_GENDER_OPTIONS = [
  {
    key: USER_GENDER.MALE,
    label: USER_GENDER_LABEL_MAPPER[USER_GENDER.MALE],
    value: USER_GENDER.MALE
  },
  {
    key: USER_GENDER.FEMALE,
    label: USER_GENDER_LABEL_MAPPER[USER_GENDER.FEMALE],
    value: USER_GENDER.FEMALE
  },
  {
    key: USER_GENDER.OTHER,
    label: USER_GENDER_LABEL_MAPPER[USER_GENDER.OTHER],
    value: USER_GENDER.OTHER
  },
]